export const REDUCER_KEY_RESULTS_PREVIEW = 'ResultsPreview';
export const RESET_STATE = 'ResultsPreview/RESET_STATE';
export const UPDATE_PREVIEW_ITEMS = 'ResultsPreview/UPDATE_PREVIEW_ITEMS';
export const SET_RESULTS_FOR_QUERY_ID = 'ResultsPreview/SET_RESULTS_FOR_QUERY_ID';
